import React, { createContext, useContext, useState } from 'react';

const MusicContext = createContext();

export const MusicProvider = ({ children }) => {
  const [isMusicPlaying, setIsMusicPlaying] = useState(false); // Start paused
  const [musicVolume, setMusicVolume] = useState(0.3);
  const [error, setError] = useState(null);
  return (
    <MusicContext.Provider value={{
      isMusicPlaying,
      setIsMusicPlaying,
      musicVolume,
      setMusicVolume,
      error,
      setError
    }}>
      {children}
    </MusicContext.Provider>
  );
};

export const useMusic = () => {
  const context = useContext(MusicContext);
  if (!context) {
    throw new Error('useMusic must be used within a MusicProvider');
  }
  return context;
};
